import Component from '../abstracts/Component';

export default class InspirationComponent extends Component {

  get SELECTORS() {
    return {
      button: '.js-load-more',
      row: '.cards-row',
    };
  }

  get CLASSES() {
    return {
      show: 'show',
    };
  }

  constructor() {
    super();
  }


  bindEvents() {
    let ctx = this;

    $('body').on('click', ctx.SELECTORS.button, function(e) {
      e.preventDefault();
      $(ctx.SELECTORS.row).each(function () {
        $(this).removeClass('d-none');
      });
      $(this).addClass('d-none');
    })
  }

  render() {
    this.bindEvents();
  }
}
